<template>
  <div>
    <div class="bg-white pt-3 border rounded shadow-sm">
      <div class="font-semibold mx-2 text-gray-600">Connections Overview</div>
      <div class=" overflow-auto mt-4 ">
        <table v-if="!loading" class="table-auto w-full mb-3 ">
          <thead> 
          <tr class="border-b font-bold">
            <td class="px-3 py-2"></td>
            <td class="px-3 py-2">Daily</td>
            <!-- <td class="px-3 py-2">Weekly</td>
            <td class="px-3 py-2">Monthly</td>
            <td class="px-3 py-2">Annually</td>
            <td class="px-3 py-2">Total</td> -->
          </tr>
          </thead>
          <tbody>
          <tr class="border-t hover:bg-gray-200">
            <td class="px-3 py-2 uppercase">
              Footfall
            </td>
            <td class="px-3 py-2">{{ Math.round(overview.footfall / overview.days) }}</td>
            <!-- <td class="px-3 py-2">{{ Math.round(overview.footfall / overview.weeks) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.footfall / overview.months) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.footfall / overview.years) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.footfall) }}</td> -->
          </tr>
          <tr class="border-t hover:bg-gray-200">
            <td class="px-3 py-2 uppercase">
              Successful Connections
            </td>
            <td class="px-3 py-2">{{ Math.round(overview.connections / overview.days) }}</td>
            <!-- <td class="px-3 py-2">{{ Math.round(overview.connections / overview.weeks) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.connections / overview.months) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.connections / overview.years) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.connections) }}</td> -->
          </tr>
          <tr class="border-t hover:bg-gray-200">
            <td class="px-3 py-2 uppercase">
              Abandoned
            </td>
            <td class="px-3 py-2">{{ Math.round(overview.abandoned / overview.days) }}</td>
            <!-- <td class="px-3 py-2">{{ Math.round(overview.abandoned / overview.weeks) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.abandoned / overview.months) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.abandoned / overview.years) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.abandoned) }}</td> -->
          </tr>

          <tr class="border-t hover:bg-gray-200">
            <td class="px-3 py-2 uppercase">
              Dwell Time
            </td>
            <td class="px-3 py-2">{{ seconds_to_readable(Math.round(overview.dwellTime / overview.days)) }}</td>
            <!-- <td class="px-3 py-2">{{ seconds_to_readable(Math.round(overview.dwellTime / overview.weeks)) }}</td>
            <td class="px-3 py-2">{{ seconds_to_readable(Math.round(overview.dwellTime / overview.months)) }}</td>
            <td class="px-3 py-2">{{ seconds_to_readable(Math.round(overview.dwellTime / overview.years)) }}</td>
            <td class="px-3 py-2">{{ seconds_to_readable(Math.round(overview.dwellTime)) }}</td> -->
          </tr>

          <tr class="border-t hover:bg-gray-200">
            <td class="px-3 py-2 uppercase">
              Bandwidth
            </td>
            <td class="px-3 py-2">{{ formatBytes(overview.bandwidth / overview.days) }}</td>
            <!-- <td class="px-3 py-2">{{ formatBytes(overview.bandwidth / overview.weeks) }}</td>
            <td class="px-3 py-2">{{ formatBytes(overview.bandwidth / overview.months) }}</td>
            <td class="px-3 py-2">{{ formatBytes(overview.bandwidth / overview.years) }}</td>
            <td class="px-3 py-2">{{ formatBytes(overview.bandwidth) }}</td> -->
          </tr>
          <tr class="border-t hover:bg-gray-200">
            <td class="px-3 py-2 uppercase">
              New Customers
            </td>
            <td class="px-3 py-2">{{ Math.round(overview.newCustomers / overview.days) }}</td>
            <!-- <td class="px-3 py-2">{{ Math.round(overview.newCustomers / overview.weeks) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.newCustomers / overview.months) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.newCustomers / overview.years) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.newCustomers) }}</td> -->
          </tr>

          <tr class="border-t hover:bg-gray-200">
            <td class="px-3 py-2 uppercase">
              Repeat Customers
            </td>
            <td class="px-3 py-2">{{ Math.round(overview.repeatCustomers / overview.days) }}</td>
            <!-- <td class="px-3 py-2">{{ Math.round(overview.repeatCustomers / overview.weeks) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.repeatCustomers / overview.months) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.repeatCustomers / overview.years) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.repeatCustomers) }}</td> -->
          </tr>
          <tr class="border-t hover:bg-gray-200">
            <td class="px-3 py-2 uppercase">
              All Customers
            </td>
            <td class="px-3 py-2">{{ Math.round(overview.totalCustomers / overview.days) }}</td>
            <!-- <td class="px-3 py-2">{{ Math.round(overview.totalCustomers / overview.weeks) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.totalCustomers / overview.months) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.totalCustomers / overview.years) }}</td>
            <td class="px-3 py-2">{{ Math.round(overview.totalCustomers) }}</td> -->
          </tr>

          </tbody>
        </table>
        <div v-else class="py-6 text-center w-full">
          <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
          <p>Loading...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import GraphQl from "../../services/graphql.service";

export default {
  name: "OverviewReport",
  components: {},
  data() {
    return {
      overview: [],
      loading: true
    }
  },
  props: {
    configs: Object
  },
  mounted() {
    this.loadStats();
  },
  watch: {
    configs: {
      handler: function () {
        this.loadStats();
      },
      deep: true
    }
  },
  methods: {
    seconds_to_readable(seconds) {
      let hours = Math.floor(seconds / 3600);
      let mins = Math.floor((seconds / 60) % 60);
      let secs = seconds % 60;
      return hours + ":" + mins + ":" + secs;
    },

    formatBytes(a, b = 2) {
      if (0 === a) return "0 Bytes";
      const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024));
      return parseFloat((a / Math.pow(1024, d)).toFixed(c)) + " " + ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
    },
    formatDate(timestamp, format) {
      return moment(timestamp).format(format);
    },
    loadStats(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true
      let params = 'endDate: "' + this.configs.endDate + '", startDate: "' + this.configs.startDate + '"';
      let query = 'overview(' + params + '){days weeks months years footfall connections abandoned upload download bandwidth dwellTime newCustomers repeatCustomers totalCustomers}'
      GraphQl.sendRequest('{' + query + '}')
          .then(response => {
            this.overview = response.overview;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>
</style>